import React, { useState, useEffect, Children, cloneElement } from 'react';
import { injectIntl } from 'react-intl';
import { useTheme } from 'ThemeContext';

import {
  Wrapper,
  Holder,
  Panel,
  Close,
  CloseIcon,
  Content
} from './Modal.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function Modal({ intl, children, visibleModal, setVisibleModal }) {
  const [closingInitiator, setClosingInitiator] = useState(undefined);
  const [openModal, setOpenModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    setOpenModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setOpenModal(false);
    setCloseModal(true);
    setTimeout(() => {
      setVisibleModal(false);
    }, 100);
  };

  const childrenElement = Children.map(children, (child, index) =>
    cloneElement(child, {
      index,
      handleClose
    })
  );

  return (
    <Wrapper>
      <Holder
        theme={theme.modal.holder}
        data-visible={visibleModal ? true : undefined}
        data-open={openModal ? true : undefined}
        data-close={closeModal ? true : undefined}
        onPointerDown={event => {
          if (event.currentTarget === event.target) setClosingInitiator(true);
          else if (closingInitiator) setClosingInitiator(false);
        }}
        onPointerUp={event => {
          if (closingInitiator && event.currentTarget === event.target)
            handleClose();
        }}
      >
        <Panel
          theme={theme.modal.panel}
          data-visible={visibleModal ? true : undefined}
          data-open={openModal ? true : undefined}
          data-close={closeModal ? true : undefined}
        >
          <Close
            theme={theme.modal.close}
            title={intl.formatMessage({ id: 'MODAL.CLOSE' })}
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon>
              <FontAwesomeIcon icon={faTimes} />
            </CloseIcon>
          </Close>
          <Content>{childrenElement}</Content>
        </Panel>
      </Holder>
    </Wrapper>
  );
}

export default injectIntl(Modal);
